import React from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonSize } from '@wix/da-ds/pkg/Buttons/types';
import SolidButton from '@wix/da-ds/pkg/Buttons/SolidButton';

export interface Props {
  className?: string;
  size?: ButtonSize;
}

const DisabledVariant: React.FC<Props> = ({ className, size = 'medium' }) => {
  const { t } = useTranslation();
  return (
    <SolidButton className={className} size={size} variant="main" priority="primary" disabled>
      {t('deviation.tier.noSubscribing')}
    </SolidButton>
  );
};
DisabledVariant.displayName = 'DisabledVariant';

export default DisabledVariant;
